import { UserGetResponse as ResGet } from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/GET";
import { UserDeleteResponse as ResDelete } from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/DELETE";
import { FromDtoFn } from "src/business.InterfaceLayer/store/types/FromDtoFn.type";
import { convertToServerResponse } from "src/business.InterfaceLayer/store/services/utils.service/convertToServerResponse";
import { USER_FIELDS } from "../../../redux/fields";
import { UserPostResponse as ResPost } from "../../../redux/api/types/POST";
import { UserPutResponse as ResPut } from "../../../redux/api/types/PUT";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";
import dateToFormat from "../../../../../services/adapters.service/dateToFormat";
import getFullName from "src/business.InterfaceLayer/store/services/adapters.service/getFullName";

export namespace AuthFromDtoPost {
	export const userCreateFromDto: FromDtoFn<ResPost.UserCreate> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: props,
			  })
			: null;
	};

	export const userStatusUpdateFromDto: FromDtoFn<ResPost.UserStatusUpdate> = (
		props,
		meta
	) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
}

export namespace AuthFromDtoPut {
	export const userChangeCoordinationFromDto: FromDtoFn<
		ResPut.UserChangeCoordination
	> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};

	export const userChangePasswordRequestFromDto: FromDtoFn<
		ResPut.UserChangePasswordRequest
	> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};

	export const userEditFromDto: FromDtoFn<ResPut.UserEdit> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
	export const userRecoveryPasswordFromDto: FromDtoFn<
		ResPut.UserRecoveryPassword
	> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
}

export namespace AuthFromDtoGet {
	export const userGetUsers: FromDtoFn<ResGet.UsersGet> = (props, meta) => {
		const data = props.map((user: any) => {
			const newUser = JSON.parse(JSON.stringify(user));

			newUser[USER_FIELDS.FULL_NAME] = getFullName(newUser);
			if (newUser[USER_FIELDS.MANAGER]) {
				newUser[USER_FIELDS.MANAGER][USER_FIELDS.FULL_NAME] = getFullName(
					newUser[USER_FIELDS.MANAGER]
				);
			}
			newUser[USER_FIELDS.CREATED_AT_FORMATTED] = dateToFormat(
				new Date(user[USER_FIELDS.CREATED_AT])
			);

			return newUser;
		});

		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: data,
			  })
			: null;
	};

	export const userGetProfile: FromDtoFn<ResGet.ProfileGet> = (props, meta) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: {
						[USER_FIELDS.AVATAR]: props?.[USER_FIELDS.AVATAR] || null,
						[USER_FIELDS.DESKTOP]: props?.[USER_FIELDS.DESKTOP] || null,
						[USER_FIELDS.NAME]: props?.[USER_FIELDS.NAME] || null,
						[USER_FIELDS.LAST_NAME]: props?.[USER_FIELDS.LAST_NAME] || null,
					},
			  })
			: null;
	};

	export const UsersRequestPassword: FromDtoFn<
		ResGet.UsersRequestPasswordGet
	> = (props, meta) => {
		const newDate = props?.map((request: any) => {
			const data = {
				...request,
				[USER_FIELDS.CREATOR_USER_ID]: request?.[USER_FIELDS.CREATOR_USER_ID],
				[USER_FIELDS.CREATED_AT]: request?.[USER_FIELDS.CREATED_AT],
				[USER_FIELDS.USER]: {
					...request?.[USER_FIELDS.USER],
					[USER_FIELDS.FULL_NAME]: getFullName(request[USER_FIELDS.USER]),
				},
				[USER_FIELDS.CREATED_AT_FORMATTED]: dateToFormat(
					new Date(request[USER_FIELDS.CREATED_AT])
				),
			};

			if (request?.[USER_FIELDS.USER]?.[USER_FIELDS.MANAGER]) {
				data[USER_FIELDS.USER][USER_FIELDS.MANAGER][USER_FIELDS.FULL_NAME] =
					getFullName(request[USER_FIELDS.USER][USER_FIELDS.MANAGER]);
			}

			return data;
		});

		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: newDate,
			  })
			: null;
	};

	export const userIDGetUsers: FromDtoFn<ResGet.UserIDGet> = (props, meta) => {
		const newUser = JSON.parse(JSON.stringify(props));

		newUser[USER_FIELDS.FULL_NAME] = getFullName(newUser);
		if (newUser[USER_FIELDS.MANAGER]) {
			newUser[USER_FIELDS.MANAGER][USER_FIELDS.FULL_NAME] = getFullName(
				newUser[USER_FIELDS.MANAGER]
			);
		}
		newUser[USER_FIELDS.CREATED_AT_FORMATTED] = dateToFormat(
			new Date(props[USER_FIELDS.CREATED_AT])
		);

		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: newUser,
			  })
			: null;
	};

	export const UserRequestPasswordID: FromDtoFn<
		ResGet.UserRequestPasswordGetID
	> = (props, meta) => {
		const data = {
			...props,
			[USER_FIELDS.CREATOR_USER_ID]: props?.[USER_FIELDS.CREATOR_USER_ID],
			[USER_FIELDS.CREATED_AT]: props?.[USER_FIELDS.CREATED_AT],
			[USER_FIELDS.USER]: {
				...props?.[USER_FIELDS.USER],
				[USER_FIELDS.FULL_NAME]: getFullName(props[USER_FIELDS.USER]),
			},
			[USER_FIELDS.CREATED_AT_FORMATTED]: dateToFormat(
				new Date(props[USER_FIELDS.CREATED_AT])
			),
		};

		if (props?.[USER_FIELDS.USER]?.[USER_FIELDS.MANAGER]) {
			data[USER_FIELDS.USER][USER_FIELDS.MANAGER][USER_FIELDS.FULL_NAME] =
				getFullName(props[USER_FIELDS.USER][USER_FIELDS.MANAGER]);
		}

		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: data,
			  })
			: null;
	};

	export const userCountGetUsers: FromDtoFn<ResGet.UsersCountGet> = (
		props,
		meta
	) => {
		return props || props === 0
			? convertToServerResponse(props, meta, {
					[USER_FIELDS.LENGTH]: props,
			  })
			: null;
	};

	export const userCountGetUsersRequestPassword: FromDtoFn<
		ResGet.UsersRequestPasswordCountGet
	> = (props, meta) => {
		return props || props === 0
			? convertToServerResponse(props, meta, {
					[USER_FIELDS.LENGTH]: props,
			  })
			: null;
	};

	export const userManagersGetUsers: FromDtoFn<ResGet.UsersManagersGet> = (
		props,
		meta
	) => {
		const newManagers = props.map((manager: any) => ({
			...manager,
			[USER_FIELDS.FULL_NAME]: getFullName(manager),
			[USER_FIELDS.CREATED_AT_FORMATTED]: dateToFormat(
				new Date(manager[USER_FIELDS.CREATED_AT])
			),
		}));
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: newManagers,
			  })
			: null;
	};
}

export namespace UserFromDtoDelete {
	export const userDelete: FromDtoFn<ResDelete.UserDelete> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
}
